import React from 'react';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import {CasinoIcon, EsportsIcon} from './AffiliatesIcons';

const CASINO_CHIPS = [
    'c_slots',
    'c_poker',
    'c_live'
];

const ESPORTS_CHIPS = [
    'CS',
    'Dota 2',
    'LoL',
    'Valorant',
    'Rainbow6',
    'HoMM 3'
];

const AffiliatesProducts = (): React.ReactElement => <section className="sec" id="products">
    <div className="wrap">
        <div className="sec-head rv">
            <div>
                <div className="eyebrow">{I18n.t('affiliate.pr_ey')}</div>
                <h2 dangerouslySetInnerHTML={{__html: I18n.t('affiliate.pr_h')}}/>
            </div>
            <a className="btn btn-sm btn-ghost" href={getLinkPath('/')} target="_blank" rel="noopener noreferrer">
                {I18n.t('affiliate.open_egb')}
            </a>
        </div>
        <div className="cards3">
            <article className="pcard rv">
                <div className="wm" aria-hidden="true"><EsportsIcon/></div>
                <div className="ico"><EsportsIcon/></div>
                <h3>{I18n.t('affiliate.p1h')}</h3>
                <p>{I18n.t('affiliate.p1p')}</p>
                <div className="chips">
                    {ESPORTS_CHIPS.map(chip => <span key={chip}>{chip}</span>)}
                </div>
            </article>
            <article className="pcard rv">
                <div className="wm" aria-hidden="true"><CasinoIcon/></div>
                <div className="ico"><CasinoIcon/></div>
                <h3>{I18n.t('affiliate.p3h')}</h3>
                <p>{I18n.t('affiliate.p3p')}</p>
                <div className="chips">
                    <span>{I18n.t('affiliate.c_slots')}</span>
                    <span>Crash</span>
                    {CASINO_CHIPS.filter(chip => chip !== 'c_slots').map(chip => <span key={chip}>
                        {I18n.t(`affiliate.${chip}`)}
                    </span>)}
                </div>
            </article>
        </div>
    </div>
</section>;

export default AffiliatesProducts;
